import { SwalMessage } from "../js/Tools";
import { validateCaptcha } from "./Captcha";

var FormRequests = function () {
  const captchaModal = document.getElementById("captcha-basic-modal");

  var formHandle = function (form) {
    // istek gönder
    $(form).on("click", '[data-send="form-request"]', function (event) {
      event.preventDefault();

      
      $(captchaModal).modal('show');

    });

    // captcha doğrulama
    $(document).on("click", '[data-form-captcha-submit]', function (event) {
      event.preventDefault();

      if (validateCaptcha()) {
        $(captchaModal).modal('hide');
        ajaxHandle(form);
      }

    });
  };


  var ajaxHandle = function (form) {

    let button = form.querySelector('[data-send="form-request"]')

    $.ajax({
      url: form.getAttribute("action"),
      type: form.getAttribute("method"),
      dataType: "json",
      data: $(form).serialize(),
      async: true,
      error: function error(xhr) {
        //console.log(xhr);
        SwalMessage(
          {
            type: "error",
            text: xhr.responseJSON.text ?? xhr.responseJSON.message,
            confirmButton: translate.ok_button
          },
          function () {
            // location.reload();
          }
        );
      },
      beforeSend: function () {
        button.setAttribute("disabled", "");
      },
      complete: function () {
        button.removeAttribute("disabled");
      },
      success: function success(xhr) {
        //console.log(xhr);

        SwalMessage(
          {
            type: 'success',
            text: xhr.text ?? xhr.message,
            confirmButton: translate.ok_button,
          },
          function () { }
        );
      }
    });
  }

  return {
    init: function () {
      var elements = document.querySelectorAll('[data-form="form-request"]');
      elements.forEach(function (element) {
        if (element) {
          formHandle(element);
        }
      });
    }
  };
}();

$(function () {
  FormRequests.init();
});


